/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-22 19:47:19
 */
import React, { useRef } from 'react'
import { useEffect, useState } from 'react'
import {
  ExclamationCircleFilled,
  LeftOutlined,
  PlusOutlined,
  RightOutlined,
} from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import {
  pageSupplier,
  selectSupplierdata,
  selectTotal,
  setCurrent,
  selectCurrent,
  setSelectId,
  setSupplierPage,
  selectSize,
  selectPageLoading,
  setPageLoading,
  submitSupplierAsync,
  deleteSupplierAsync,
  getSynchrVendersFn,
} from './supplierSlice'
import { Columns } from './columns'
import { SupplierModal } from './modal'
import { SupplierQuery } from './query'
import { supplierParams } from '../../services/supplier'
import { Button, Carousel, Col, Modal, notification } from 'antd'
import { NavBar } from '../../compnents/nav/NavBar'
import { EditableList } from '../../compnents/list/EditableList'
import styles from './supplier.module.css'
import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../app/store'
import { PurchaseModal } from '../putstorelist/purchaseModal'
import {
  selectChainId,
  selectChainType,
  selectTenantId,
} from '../../app/applicationSlice'
import { UploadFile } from 'antd/lib/upload/interface'
import { getUrl } from '../treatment/diagnosis/diagnosisSlice'
import { getAddCompanyRecordAsync } from '../firstTimeBusinessManagement/businessManagement/businessManagementSlice'

export const Supplier = () => {
  const dispatch = useDispatch()

  const dispatch_ = useDispatch<RootDispatch>()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const total = useSelector(selectTotal)

  const Current = useSelector(selectCurrent)

  const size = useSelector(selectSize)

  const [id, setId] = useState<any>()

  const [queries, setQueries] = useState<supplierParams>()

  const [ismodalVisible, setIsmodalVisible] = useState(false)

  const [isPicModalVisible, setIsPicModalVisible] = useState<any>()

  const [issSuppierModalVisible, setIsSuppierModalVisible] = useState(false) // 控制导入弹窗是否显示

  const pageLoadingRX = useSelector(selectPageLoading)

  const [syncGoodsLoading, setSyncGoodsLoading] = useState(false)

  const [dataIndex, setDataIndex] = useState<any>(1)

  const [lookPicList, setLookPicList] = useState<any>()

  const [imgList, setImgList] = useState<any>()

  const chainType = useSelector(selectChainType)

  useEffect(() => {
    getPage()
  }, [queries, Current, size])

  const getPage = () => {
    dispatch(setPageLoading(true))
    dispatch(pageSupplier({ ...queries, current: Current, size }))
    setTimeout(() => {
      dispatch(setPageLoading(false))
    }, 3000)
  }

  const data = useSelector(selectSupplierdata)

  useEffect(() => {
    if (isPicModalVisible) {
      setDataIndex(1)
      if (imgList?.length) {
        setLookPicList([])

        const fetchPromises = imgList.map((v: any) => getImgUrl(v))
        Promise.all(fetchPromises)
          .then((urls) => {
            setLookPicList(urls.filter((url) => url !== undefined))
          })
          .catch((error) => {
            return
          })
      }
    } else {
      setDataIndex(1)
    }
  }, [isPicModalVisible])

  const getImgUrl = (v: any): Promise<any> => {
    return dispatch_(getUrl({ fileName: v.url }))
      .then(unwrapResult)
      .then((v: any) => {
        const proxy =
          window.location.origin.indexOf('his.develop.hydhis.com') >= 0
            ? '/proxyToOssDevPrivate'
            : window.location.origin.indexOf('his.test.hydhis.com') >= 0
            ? '/proxyToOssTestPrivate'
            : window.location.origin.indexOf('hydhis.cn') >= 0
            ? '/proxyToOssProdPrivate'
            : '/proxyToOssProdPrivate'

        const url =
          (window.location.origin?.includes('localhost')
            ? 'http://hydhis.cn'
            : window.location.origin) +
          proxy +
          '/' +
          v

        return url // Return the URL to be collected in the array
      })
      .catch((error) => {
        return
      })
  }

  const getAddCompanyRecord = (supplierId?: any) => {
    dispatch_(getAddCompanyRecordAsync(supplierId))
      .then(unwrapResult)
      .then((v: any) => {
        notification.success({
          message:'操作成功'
        })
        getPage()
      })
  }
  return (
    <>
      <Col
        style={{
          margin: '10px 20px',
        }}
      >
        <NavBar
          where={['供应商管理', '供应商设置']}
          backtrace={{
            name: '库房工作站',
            path: '/storage/station',
            state: {
              station: '8',
            },
          }}
          buttons={
            <div>
              {tenantId == chainId && chainType == 1 && (
                <Button
                  type='primary'
                  loading={syncGoodsLoading}
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    Modal.confirm({
                      centered: true,
                      title: '确认操作',
                      content: (
                        <div>
                          <ExclamationCircleFilled
                            style={{ color: '#FFAE55', fontSize: 18 }}
                          />
                          &nbsp;是否确认供应商同步？
                        </div>
                      ),
                      okText: '确认',
                      cancelText: '取消',
                      icon: null,
                      onOk: () => {
                        setSyncGoodsLoading(true)
                        dispatch_(getSynchrVendersFn())
                          .then(unwrapResult)
                          .then((v:any) => {
                            notification.success({
                              message: v || '供应商同步成功',
                              duration: 3,
                            })
                            getPage()
                          })
                          .finally(() => {
                            setSyncGoodsLoading(false)
                          })
                      },
                    })
                  }}
                >
                  供应商同步
                </Button>
              )}
              <Button
                type='primary'
                style={{ marginRight: '10px' }}
                onClick={() => {
                  setIsSuppierModalVisible(true)
                }}
              >
                供应商导入
              </Button>
              <Button
                type='primary'
                onClick={() => {
                  setIsmodalVisible(true)
                }}
              >
                <PlusOutlined />
                新增
              </Button>
            </div>
          }
        />
      </Col>
      <div className={styles.content}>
        <SupplierQuery
          onValueChange={(v) => {
            setQueries(v)
          }}
        />
        <EditableList
          className={styles.suppliertable}
          loading={pageLoadingRX}
          page={{
            items: data,
            current: Current,
            size,
            total,
          }}
          onChangePage={(current, pageSize) => {
            dispatch(setSupplierPage(pageSize))
            dispatch(setCurrent(current))
          }}
          columns={Columns((t: any, type) => {
            if (type == 'edit') {
              dispatch(setSelectId(t?.id))
              const fileUrl = t?.fileUrl?.startsWith('@')
                ? t?.fileUrl?.replace(/^@+/, '')
                : t?.fileUrl
              const data = fileUrl
                ? fileUrl?.split(',').map((v: any) => {
                    return ({
                      name: v.split('@')[0],
                      uid: v.split('@')[1] ? v.split('@')[1] : v.split('@')[0],
                      url: v.split('@')[2] ? v.split('@')[2] : v.split('@')[0],
                    } as unknown) as UploadFile
                  })
                : []

              setImgList(data)
              setIsmodalVisible(true)
            } else if (type == 'delete') {
              dispatch_(
                deleteSupplierAsync({
                  id: t?.id,
                })
              )
                .then(unwrapResult)
                .then(() => {
                  dispatch(pageSupplier({ ...queries, current: Current, size }))
                })
            } else if (type == 'lookPic') {
              const fileUrl = t?.fileUrl?.startsWith('@')
                ? t?.fileUrl?.replace(/^@+/, '')
                : t?.fileUrl
              const data = fileUrl
                ? fileUrl?.split(',').map((v: any) => {
                    return ({
                      name: v.split('@')[0],
                      uid: v.split('@')[1] ? v.split('@')[1] : v.split('@')[0],
                      url: v.split('@')[2] ? v.split('@')[2] : v.split('@')[0],
                    } as unknown) as UploadFile
                  })
                : []

              setImgList(data)
              setIsPicModalVisible(true)
            } else if (type == 'firstBusssiess') {
              getAddCompanyRecord(t?.id)
            }
          }, size * (Current - 1))}
          onRow={(t: any) => ({
            onDoubleClick: () => {
              dispatch(setSelectId(t.id))
              setIsmodalVisible(true)
              setId(t.id)
              const fileUrl = t?.fileUrl?.startsWith('@')
                ? t?.fileUrl?.replace(/^@+/, '')
                : t?.fileUrl
              const data = fileUrl
                ? fileUrl?.split(',').map((v: any) => {
                    return ({
                      name: v.split('@')[0],
                      uid: v.split('@')[1] ? v.split('@')[1] : v.split('@')[0],
                      url: v.split('@')[2] ? v.split('@')[2] : v.split('@')[0],
                    } as unknown) as UploadFile
                  })
                : []

              setImgList(data)
            },
          })}
        />
      </div>
      <SupplierModal
        imgList={imgList}
        id={id}
        visible={ismodalVisible}
        onOk={() => {
          dispatch(pageSupplier({ ...queries, current: Current, size }))
          setIsmodalVisible(false)
          dispatch(setSelectId(0))
          setId('')
          setImgList([])
        }}
        onCancel={() => {
          setIsmodalVisible(false)
          dispatch(setSelectId(0))
          setId('')
          setImgList([])
        }}
      />
      <PurchaseModal
        state={4}
        isPurchaseModalVisible={issSuppierModalVisible}
        onOk={() => {
          setIsSuppierModalVisible(false)
          getPage()
        }}
        onCancel={() => {
          setIsSuppierModalVisible(false)
          getPage()
        }}
        refresh={() => {
          getPage()
        }}
      />
      <Modal
        width={1200}
        title='查看'
        className={styles.modalContent}
        visible={isPicModalVisible}
        onOk={() => {
          setIsPicModalVisible(false)
        }}
        onCancel={() => {
          setIsPicModalVisible(false)
        }}
      >
        <div
          style={{ display: 'flex', width: '100%', flexDirection: 'column' }}
        >
          <div style={{ display: 'flex', width: '100%', height: '520px' }}>
            <div
              style={{
                width: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <LeftOutlined
                disabled={dataIndex == 1 ? true : false}
                onClick={() => {
                  if (dataIndex == 1) {
                    setDataIndex(1)
                  } else {
                    setDataIndex(dataIndex - 1)
                  }
                }}
              />
            </div>
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={lookPicList?.[dataIndex - 1]}
                style={{
                  maxWidth: '1200px',
                  maxHeight: '500px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              ></img>
            </div>
            <div
              style={{
                width: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <RightOutlined
                disabled={dataIndex == lookPicList?.length ? true : false}
                onClick={() => {
                  if (dataIndex == lookPicList?.length) {
                    setDataIndex(lookPicList?.length)
                  } else {
                    setDataIndex(dataIndex + 1)
                  }
                }}
              />
            </div>
          </div>
          <div
            style={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {dataIndex}/{lookPicList?.length > 0 ? lookPicList?.length : 0}
          </div>
        </div>
      </Modal>
    </>
  )
}
